import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Avatar, Box, Chip, Grid, Paper, TableFooter, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Select from 'react-select';

import AppButton from "components/CustomButtons/AppButton";
import AppColor from "utilities/AppColor";
import { useParams } from 'react-router';
import moment from "moment-timezone";
import {
  fetchBookingDetail,
  reduceCancelBooking,
  reduceUpdateBooking,
  reduceUpdateWorkingTime,
  approvalExpressInterest,
  getBookingTask
} from "store/slices/booking";
// import { fetchJobDetail } from "store/slices/job";
import {
  fetchListRateByBookingId
} from "store/slices/rate";
import { getAuthInfo } from "store/slices/auth";

import { useDispatch, useSelector } from 'react-redux';
import { BOOKING_STATUS } from 'config/AppConfig';
import ClientBookingTag from './ClientBookingTag';
import AppConfirmDialog from 'components/Dialog/AppConfirmDialog';
import { SYSTEM_ROLE } from 'config/AppConfig';
import { Link, useHistory } from 'react-router-dom';
import { Rating } from "@material-ui/lab";
import AccountIcon from "assets/icons/user-circle-regular.svg";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Table from "@material-ui/core/Table";
import { fetchWorkerDetail } from "../../../../store/slices/worker";
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import AppUtil from "../../../../utilities/AppUtil";
import AppConfig from 'config/AppConfig';
import AppDialog from 'components/Dialog/AppDialog';
import AppInput from 'components/Input/AppInput';
import InputAutocompleteAddress from 'components/Input/InputAutocompleteAddress';
import CustomDateTimePicker from 'components/Input/CustomDateTimePicker';
import { reduceUpdateEndBooking } from 'store/slices/booking';
import Loading from 'components/Common/Loading';

const useStyles = makeStyles(() => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexStart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  bold: {
    fontWeight: 700
  },
  boxInfo: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  leftInfo: {
    flex: '1 0 300px'
  },
  rightInfo: {
    flex: '1 0 300px'
  },
  wrapInfo: {
    display: 'flex',
    marginBottom: '0.5rem'
  },
  title: {
    fontWeight: 700,
    flex: '1 0 0px'
  },
  info: {
    flex: '2 0 0px',
    paddingLeft: '0.5rem'
  },
  infoLink: {
    flex: '2 0 0px',
    paddingLeft: '0.5rem',
    textDecoration: 'underline',
    color: AppColor.blue
  },
  control: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '1rem'
  },
  trackingLog: {
    maxWidth: 500,
    width: '100%',
    border: '2px solid #e5e5e5',
    borderRadius: 4,
    padding: '0.5rem'
  },
  linkMap: {
    padding: '0 1rem',
    width: 'fit-content'
  },
  wrapEstimate: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: 4,
    padding: '0.5rem',
    margin: '0.5rem 0',
    // display: 'flex',
    maxWidth: 800,
    flex: '1 0 0px'
  },
  wrapRating: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: 4,
    padding: '0.5rem',
    margin: '0.5rem 0',
    display: 'flex',
    maxWidth: 500,
    flex: '1 0 0px',
    background: 'rgba(91, 210, 255, 0.2)',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiRating-label': {
      color: AppColor.mainColor
    }
  },
  wrapVote: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: 4,
    padding: '0.5rem',
    margin: '0.5rem 0',
    display: 'flex',
    maxWidth: 500,
    flex: '1 0 0px',
    background: 'rgba(91, 210, 255, 0.08)',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiRating-label': {
      color: AppColor.mainColor,
      fontSize: '2.5rem'
    },
    '& .label-name': {
      fontWeight: 700,
      fontSize: '1.3rem'
    }
  },
  wrapAvatar: {
    width: 60,
    height: 60,
    '& .avatar': {
      width: '100%',
      height: '100%'
    }
  },
  selectRate: {
    width: '100%',
    maxWidth: 500,
    margin: '1rem 0'
  },
  rating: {
    color: AppColor.mainColor
  },
  travelHistoryFooter: {
    borderBottom: 0,
  },
  travelHistoryLeft: {
    width: 160,
    paddingLeft: 0,
    paddingRight: 0,
  },
  wrapTasks: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    borderRadius: 4,
    padding: '1rem',
    margin: '1.5rem 0',
    maxWidth: 800,
    backgroundColor: AppColor.white,
    textAlign: 'center',
    width: 500,
  },
  taskHeader: {
    // fontWeight: 700,
    marginBottom: '0.5rem',
    fontSize: '1rem',
    color: AppColor.black,
  },
  taskItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.25rem 0',
  },
  taskText: {
    fontSize: '14px',
    color: AppColor.black,
  },
  taskTextCompleted: {
    fontSize: '14px',
    color: AppColor.greyDark,
    textDecoration: 'line-through',
  }
}));

const FORMAT_DATE_TIME = 'DD/MM/YYYY HH:mm';

const customStyles = {
  valueContainer: (provided) => {
    const padding = '3px';
    return { ...provided, padding };
  },
  singleValue: (provided) => {
    const whiteSpace = 'unset';
    return { ...provided, whiteSpace };
  }
}

const ClientBookingForm = () => {
  const { t } = useTranslation();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const history = useHistory();
  const classes = useStyles();
  const { id: bookingId } = useParams();
  const dispatch = useDispatch();

  const [bookingDetail, setBookingDetail] = useState({});
  // const [estimate, setEstimate] = useState();
  // const [listRate, setListRate] = useState([]);
  // const [selectedRate, setSelectedRate] = useState();
  // const [rateAdmin, setRateAdmin] = useState();
  const [showConfirmCancel, setShowConfirmCancel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [workerRating, setWorkerRating] = useState(0);
  const [workerDetail, setWorkerDetail] = useState({});
  const [updateStartTime, setUpdateStartTime] = useState('');
  const [updateEndTime, setUpdateEndTime] = useState('');
  // const [totalHours, setTotalHours] = useState(0);
  const [showEndBoking, setShowEndBoking] = useState(false);
  const [showUpdateTravelHistory, setShowUpdateTravelHistory] = useState(false);
  const [initializeTravelHistory, setInitializeTravelHistory] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showConfirmApprove, setShowConfirmApprove] = useState(false);
  const [showConfirmReject, setShowConfirmReject] = useState(false);
  const [bookingTaskListState, setBookingTaskListState] = useState([]);

  const [listRateMorning, setListRateMorning] = useState([]);
  const [listRateAfternoon, setListRateAfternoon] = useState([]);
  const [listRateEvening, setListRateEvening] = useState([]);
  const [listRateNight, setListRateNight] = useState([]);

  const [selectedRateMorning, setSelectedRateMorning] = useState();
  const [selectedRateAfternoon, setSelectedRateAfternoon] = useState();
  const [selectedRateEvening, setSelectedRateEvening] = useState();
  const [selectedRateNight, setSelectedRateNight] = useState();

  const authInfo = useSelector(getAuthInfo) || {};
  const { role } = authInfo;

  const isAdmin = role === SYSTEM_ROLE.SUPER_ADMIN || role === SYSTEM_ROLE.MANAGER || role === SYSTEM_ROLE.COMPANY;

  const {
    bookingStatus,
    dayOfWeek,
    shiftType,
    startTime,
    endTime,
    date,
    jobId,
    rating,
    realStartTime,
    realEndTime,
    bookingTrackingList,
    distance,
    originLat,
    originLng,
    destinationLat,
    destinationLng,
    originAddress,
    destinationAddress,
    job: {
      title: jobTitle,
      description: jobDescription,
      phone,
      address1
      // department,
      // floor
    } = {},
    client: {
      firstName,
      lastName,
      organizationName
    } = {},
    worker = {},
    rateShiftTypeList = [],
  } = bookingDetail;

  const isCanNotChangeRate = bookingStatus === BOOKING_STATUS.DONE || bookingStatus === BOOKING_STATUS.ON_GOING || bookingStatus === BOOKING_STATUS.NO_CLOCK_IN || bookingStatus === BOOKING_STATUS.CANCEL || bookingStatus === BOOKING_STATUS.NO_ACCEPTED || bookingStatus === BOOKING_STATUS.EXPRESS_INTEREST;

  useEffect(() => {
    if (bookingId) {
      _loadData();
      isAdmin && loadListRateByBookingId();
      _loadBookingTaskList();
    }
  }, [bookingId]);

  useEffect(() => {
    if (bookingDetail) {
      let tmpStartTime = moment(realStartTime).format('YYYY/MM/DD HH:mm');
      let tmpEndTime = moment(realEndTime).format('YYYY/MM/DD HH:mm');

      // if (shiftType === 'NIGHT') {
      //   if (moment(tmpStartTime).hours() <= 6) {
      //     tmpStartTime = moment(tmpStartTime).add(1, 'day');
      //   }
      //   if (moment(tmpEndTime).hours() <= 6) {
      //     tmpEndTime = moment(tmpEndTime).add(1, 'day');
      //   }
      // }

      setUpdateStartTime(tmpStartTime);
      setUpdateEndTime(tmpEndTime);
    }
  }, [bookingDetail]);

  useEffect(() => {
    if (bookingDetail && rateShiftTypeList && listRateMorning) {
      const rateShiftType = rateShiftTypeList.filter(item => item.shiftType === 'MORNING')[0]
      if (rateShiftType) {
        const bookingRate = listRateMorning.filter(item => item.id === rateShiftType.rateId)[0];
        if (bookingRate) {
          // setRateAdmin(bookingRate);
          setSelectedRateMorning({
            value: bookingRate,
            label: bookingRate.name
          });
        }
      }
    }
  }, [bookingDetail, listRateMorning]);

  useEffect(() => {
    if (bookingDetail && listRateAfternoon) {
      const rateShiftType = rateShiftTypeList.filter(item => item.shiftType === 'AFTERNOON')[0]
      if (rateShiftType) {
        const bookingRate = listRateAfternoon.filter(item => item.id === rateShiftType.rateId)[0];
        if (bookingRate) {
          setSelectedRateAfternoon({
            value: bookingRate,
            label: bookingRate.name
          });
        }
      }
    }
  }, [bookingDetail, listRateAfternoon]);

  useEffect(() => {
    if (bookingDetail && listRateEvening) {
      const rateShiftType = rateShiftTypeList.filter(item => item.shiftType === 'EVENING')[0]
      if (rateShiftType) {
        const bookingRate = listRateEvening.filter(item => item.id === rateShiftType.rateId)[0];
        if (bookingRate) {
          setSelectedRateEvening({
            value: bookingRate,
            label: bookingRate.name
          });
        }
      }
    }
  }, [bookingDetail, listRateEvening]);

  useEffect(() => {
    if (bookingDetail && listRateNight) {
      const rateShiftType = rateShiftTypeList.filter(item => item.shiftType === 'NIGHT')[0]
      if (rateShiftType) {
        const bookingRate = listRateNight.filter(item => item.id === rateShiftType.rateId)[0];
        if (bookingRate) {
          setSelectedRateNight({
            value: bookingRate,
            label: bookingRate.name
          });
        }
      }
    }
  }, [bookingDetail, listRateNight]);

  const _loadData = async () => {
    setIsLoading(true);
    const result = await dispatch(fetchBookingDetail({ id: bookingId }));
    setIsLoading(false);
    const { payload } = result;
    if (payload && payload.id) {
      setBookingDetail(payload);
      // _loadJobData(payload.jobId, payload);
      _loadWorkerData(payload.workerId);
    } else {
      history.push(isAdmin ? '/admin/booking' : '/booking');
    }
  };
  // const _loadJobData = async (jobId, bookingInfo) => {
  //   const result = await dispatch(fetchJobDetail({ id: jobId }));
  //   const { payload } = result;
  //   if (payload && !isAdmin) {
  //     _loadEstimatePrice(payload, bookingInfo);
  //   }
  // };
  const _loadWorkerData = async (workerId) => {
    const result = await dispatch(fetchWorkerDetail({ workerId: workerId }));
    const { payload } = result;
    if (payload && payload.id) {
      setWorkerDetail(payload);
    }
  };
  const _loadBookingTaskList = async () => {
    const result = await dispatch(getBookingTask({ bookingId }));
    if (result.payload && result.payload.length > 0) {
      setBookingTaskListState(result.payload[0].tasksList || []);
    }
  };
  // const _loadEstimatePrice = async (jobInfo, bookingInfo) => {
  //   const params = {
  //     bookingId: bookingInfo.id
  //   };
  //   const result = await dispatch(reduceCalculatePrice(params));
  //   const { payload } = result;
  //   if (payload) {
  //     setEstimate(payload);
  //   }
  // };
  const loadListRateByBookingId = async () => {
    const result = await dispatch(fetchListRateByBookingId({ bookingId: bookingId }));
    const { payload } = result;
    if (payload) {
      // setListRate(payload);
      const ratesMorning = [];
      const ratesAfternoon = [];
      const ratesEvening = [];
      const ratesNight = [];
      for (let i = 0; i < payload.length; i++) {
        switch (payload[i].shiftType) {
          case 'MORNING':
            ratesMorning.push(payload[i]);
            break;
          case 'AFTERNOON':
            ratesAfternoon.push(payload[i]);
            break;
          case 'EVENING':
            ratesEvening.push(payload[i]);
            break;
          case 'NIGHT':
            ratesNight.push(payload[i]);
            break;
          default:
            break;
        }
      }
      setListRateMorning(ratesMorning);
      setListRateAfternoon(ratesAfternoon);
      setListRateEvening(ratesEvening);
      setListRateNight(ratesNight);
    }
  };
  const handleApprovalExpressInterest = async (isAccept) => {
    setIsLoading(true);
    if (isAccept) {
      setShowConfirmApprove(false);
    } else {
      setShowConfirmReject(false);
    }
    const result = await dispatch(approvalExpressInterest({ bookingId: bookingId, isAccept: isAccept }));
    setIsLoading(false);
    if (result.payload) {
      _loadData();
    }
  };
  const handleCancelBooking = async () => {
    setIsLoading(true);
    setShowConfirmCancel(false);
    const result = await dispatch(reduceCancelBooking({ bookingId: bookingId }));
    setIsLoading(false);
    const { payload } = result;
    if (payload) {
      history.push('/admin/booking');
    }
  };
  const handleUpdateBooking = async () => {
    setIsLoading(true);
    bookingStatus === BOOKING_STATUS.DONE && isAdmin && await handleUpdateWorkingTime();
    const params = {
      id: bookingId,
      // rateId: !isAdmin ? bookingDetail.rateId : selectedRate.value
    };
    // Update rate
    if (isAdmin && !isCanNotChangeRate) {
      const updateRateBookings = [];
      if (selectedRateMorning && selectedRateMorning.value && selectedRateMorning.value.id) {
        updateRateBookings.push(
          {
            rateId: selectedRateMorning.value.id,
            shiftType: 'MORNING',
          }
        )
      }
      if (selectedRateAfternoon && selectedRateAfternoon.value && selectedRateAfternoon.value.id) {
        updateRateBookings.push(
          {
            rateId: selectedRateAfternoon.value.id,
            shiftType: 'AFTERNOON',
          }
        )
      }
      if (selectedRateEvening && selectedRateEvening.value && selectedRateEvening.value.id) {
        updateRateBookings.push(
          {
            rateId: selectedRateEvening.value.id,
            shiftType: 'EVENING',
          }
        )
      }
      if (selectedRateNight && selectedRateNight.value && selectedRateNight.value.id) {
        updateRateBookings.push(
          {
            rateId: selectedRateNight.value.id,
            shiftType: 'NIGHT',
          }
        )
      }
      if (updateRateBookings && updateRateBookings.length > 0) {
        params['updateRateBookings'] = updateRateBookings;
      }
    }

    if (workerRating) {
      params['rating'] = workerRating;
    }

    await dispatch(reduceUpdateBooking(params));
    setIsLoading(false);
    _loadData();
    loadListRateByBookingId();
  }
  const handleUpdateWorkingTime = async () => {
    const params = {
      bookingId: bookingId,
      startTimeStr: moment(updateStartTime).format('YYYY/MM/DD HH:mm'),
      endTimeStr: moment(updateEndTime).format('YYYY/MM/DD HH:mm'),
    }
    await dispatch(reduceUpdateWorkingTime(params));
    loadListRateByBookingId();
  };

  const _submitUpdateTravelHistory = async (data) => {
    setSubmitting(true);
    const requestParams = {
      id: bookingId,
      distance: data.distance || data.distance !== '' ? data.distance : null
    };
    if (data.latLngOrigin) {
      requestParams.originLat = data.latLngOrigin.lat;
      requestParams.originLng = data.latLngOrigin.lng;
      requestParams.originAddress = data.originAddress;
    } else if (data.originAddress !== '') {
      requestParams.originAddress = null;
    }

    if (data.latLngDestination) {
      requestParams.destinationLat = data.latLngDestination.lat;
      requestParams.destinationLng = data.latLngDestination.lng;
      requestParams.destinationAddress = data.destinationAddress;
    } else if (data.destinationAddress !== '') {
      requestParams.destinationAddress = null;
    }
    const { payload } = await dispatch(reduceUpdateBooking(requestParams));
    setSubmitting(false);
    setShowUpdateTravelHistory(false);
    if (payload) {
      _loadData();
      loadListRateByBookingId();
    }
  }
  const handleEndBooking = async (data) => {
    if (data.realEndTimeStr) {
      const realEndTimeStr = moment(data.realEndTimeStr).format('YYYY/MM/DD HH:mm:ss');
      setSubmitting(true);
      const requestParams = { bookingId, realEndTimeStr };
      const { payload } = await dispatch(reduceUpdateEndBooking(requestParams));
      setSubmitting(false);
      setShowEndBoking(false);
      if (payload) {
        _loadData();
      }

    }
  }


  const renderEstimatePrice = (data, forWorker) => {
    if (!data || !data.value || !data.value.workerPrice || !data.value.clientPrice || !data.label) {
      return null;
    }
    const { rate, hours, shiftType, totalPrice } = forWorker ? data.value.workerPrice : data.value.clientPrice;
    var rateOptions = [];
    switch (shiftType) {
      case 'MORNING':
        rateOptions = listRateMorning;
        break;
      case 'AFTERNOON':
        rateOptions = listRateAfternoon;
        break;
      case 'EVENING':
        rateOptions = listRateEvening;
        break;
      case 'NIGHT':
        rateOptions = listRateNight;
        break;
      default:
        break;
    }
    return (
      <Grid container spacing={1} key={`estimate-shift-details-for-worker-${data.label}`}>
        <Grid item xs={5} className={isMobile ? classes.flexStart : classes.flexCenter} style={{ padding: isMobile ? '0px' : '0 1rem' }}>
          {
            isCanNotChangeRate
              ? <span>{data.label}</span>
              : <Select
                name={`select-rate-${shiftType}`}
                className={classes.selectRate}
                styles={customStyles}
                value={data}
                options={rateOptions.map(item => {
                  return {
                    value: item,
                    label: item.name
                  }
                })}
                onChange={option => {
                  switch (shiftType) {
                    case 'MORNING':
                      setSelectedRateMorning(option)
                      break;
                    case 'AFTERNOON':
                      setSelectedRateAfternoon(option)
                      break;
                    case 'EVENING':
                      setSelectedRateEvening(option)
                      break;
                    case 'NIGHT':
                      setSelectedRateNight(option)
                      break;
                    default:
                      break;
                  }
                }}
                isDisabled={isCanNotChangeRate}
              />
          }
        </Grid>
        <Grid item xs={5} style={{ display: 'flex', alignItems: 'center', paddingLeft: isMobile ? '5px' : '10px' }}>
          <Box>
            <span className={classes.bold}>{t('label.hoursValue', { value: hours })}</span>
            <span>{` ${t(`shift.${shiftType}`)} at `}</span>
            <span>{`$${AppUtil.formatMoney(rate.toFixed(2))}/hour`}</span>
          </Box>
        </Grid>
        <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box className={classes.bold}>{`$${AppUtil.formatMoney(totalPrice.toFixed(2))}`}</Box>
        </Grid>
      </Grid>
    );
  };


  // useEffect(() => {
  //   if (selectedRate) {
  //     const bookingRate = listRate.filter(item => item.id === selectedRate.value)[0];
  //     if (bookingRate) {
  //       setRateAdmin(bookingRate);
  //     }
  //   }
  // }, [selectedRate]);

  const timeValidate = Yup.object().shape({
    startTime: Yup.date()
      .required("validation.required")
      .when('endTime', (endTime, schema) => {
        if (endTime && endTime !== '') {
          return schema.max(
            moment(endTime).subtract(1, 'minutes').format('YYYY/MM/DD HH:mm'),
            "validation.startTimeMustBeBeforeEndTime"
          )
        }
      }),
    endTime: Yup.date()
      .required("validation.required")
      .when('startTime', (startTime, schema) => {
        if (startTime && startTime !== '') {
          return schema.min(
            moment(startTime).add(1, 'minutes').format('YYYY/MM/DD HH:mm'),
            "validation.endTimeMustBeAfterStartTime"
          )
        }
      })
  },
    [
      ["startTime", "endTime"],
      ["endTime", "startTime"],
    ]
  );
  if (isLoading && (!bookingDetail || Object.keys(bookingDetail).length === 0)) {
    return <Loading />;
  }
  return (
    <React.Fragment>
      <Box className={classes.boxInfo}>
        <Box className={classes.leftInfo}>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.jobTitle')}</span>
            {
              isAdmin
                ? (
                  <span className={classes.info}>{jobTitle}</span>
                )
                : (
                  <Link to={`/jobs/detail/${jobId}`} className={classes.infoLink}>{jobTitle}</Link>
                )
            }
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.jobDescription')}</span>
            <span className={classes.info}>{jobDescription}</span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.customerName')}</span>
            <span className={classes.info}>{organizationName ? organizationName : `${firstName} ${lastName}`}</span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.address')}</span>
            <span className={classes.info}>{address1}</span>
          </Box>
        </Box>
        <Box className={classes.rightInfo}>
          {/* <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.department')}</span>
            <span className={classes.info}>{department}</span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.floor')}</span>
            <span className={classes.info}>{floor}</span>
          </Box> */}
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.phoneNumber')}</span>
            <span className={classes.info}>{phone}</span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.date')}</span>
            <span className={classes.info}>{AppUtil.formatDate(date, AppConfig.DATE_FORMAT.DEFAULT)}</span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.time')}</span>
            <span className={classes.info}>
              {`${t(`daysOfTheWeek.${dayOfWeek}`)}, ${t(`shift.${shiftType}`)} ${startTime ? moment(startTime).format('HH:mm') : '00:00'} - ${endTime ? moment(endTime).format('HH:mm') : '00:00'}`}
            </span>
          </Box>
          <Box className={classes.wrapInfo}>
            <span className={classes.title}>{t('label.status')}</span>
            <span className={classes.info}>
              <Chip
                style={{
                  backgroundColor: BOOKING_STATUS.BOOKED === bookingStatus
                    ? AppColor.green
                    : BOOKING_STATUS.WAITING === bookingStatus
                      ? AppColor.orange
                      : BOOKING_STATUS.ON_GOING === bookingStatus
                        ? AppColor.violet
                        : BOOKING_STATUS.CANCEL === bookingStatus
                          ? AppColor.red
                          : BOOKING_STATUS.NO_CLOCK_IN === bookingStatus
                            ? AppColor.yellow
                            : BOOKING_STATUS.NO_ACCEPTED === bookingStatus
                              ? AppColor.cinnabar
                              : BOOKING_STATUS.EXPRESS_INTEREST === bookingStatus
                                ? AppColor.pink
                                : AppColor.blue,
                  color: AppColor.white
                }}
                size="small"
                label={BOOKING_STATUS.WAITING === bookingStatus ? t(`bookingStatus.PENDING`) : t(`bookingStatus.${bookingStatus}`)}
              />
            </span>
          </Box>
        </Box>
      </Box>
      <Box>
        <ClientBookingTag isAdmin={isAdmin} userInfo={workerDetail} />
      </Box>
      {bookingTaskListState && bookingTaskListState.length > 0 && (
        <Box mt={2}>
          <Box className={classes.taskHeader}>{t('label.tasks')}</Box>
          <Box display="flex" justifyContent="center">
            <Box className={classes.wrapTasks}>
              {bookingTaskListState.map((task) => (
                <Box key={task.taskId} className={classes.taskItem}>
                  <Checkbox
                    checked={task.isCompleted}
                    disabled
                    color="primary"
                    style={{ color: task.isCompleted ? AppColor.mainColor : undefined }}
                  />
                  <span className={task.isCompleted ? classes.taskTextCompleted : classes.taskText}>
                    {task.taskName}
                  </span>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      {
        bookingTrackingList && bookingStatus === BOOKING_STATUS.DONE && (
          <Box>
            <Box>{t('label.tracking_log')}</Box>
            <Box>
              <Formik
                initialValues={{
                  startTime: updateStartTime,
                  endTime: updateEndTime
                }}
                validationSchema={timeValidate}
                enableReinitialize
              >
                {() => (
                  <Form>
                    <Box display="flex" justifyContent="center">
                      <Box className={classes.trackingLog}>
                        <Box display="flex">
                          <Box className={classes.bold} textAlign="center" flex="3 0 0">{t('label.working_time')}</Box>
                          <Box className={classes.bold} textAlign="center" flex="1 0 0">{t('label.location')}</Box>
                        </Box>
                        <Box display="flex" alignItems="center" padding="0.5rem 0">
                          <Box flex="3 0 0" display="flex" alignItems="center">
                            <Box className="mr-1" minWidth={90} fontWeight={700}>{t('label.startTime')}</Box>
                            {/* <Field
                              component={SelectTime}
                              name='startTime'
                              required
                              onSelected={(value) => {
                                setUpdateStartTime(value);
                              }}
                              minTime={shiftType === 'NIGHT'
                                ? moment().hours(0).minutes(0).format('HH:mm')
                                : moment().hours(6).minutes(0).format('HH:mm')
                              }
                              style={{
                                marginBottom: 0,
                                flex: '1 0 0px'
                              }}
                              isSleepover={shiftType === 'NIGHT'}
                              shouldDisableTime={({timeValue, clockType}) => {
                                if (shiftType === 'NIGHT') {
                                  if (clockType === "hours" && (timeValue >= 12 || timeValue <= 5)) {
                                    return true;
                                  }
                                  if (clockType === "minutes" && (timeValue >= 0 || timeValue <= 59)) {
                                    return true;
                                  }
                                  return false;
                                } else {
                                  return true;
                                }
                              }}
                            /> */}
                            <Field
                              component={CustomDateTimePicker}
                              name='startTime'
                              required
                              hiddenIconClose={true}
                              notCheckTouched={true}
                              style={{ marginBottom: 0 }}
                              InputProps={{ fullWidth: true }}
                              onChange={(value => {
                                setUpdateStartTime(moment(value).format('YYYY/MM/DD HH:mm'));
                              })}
                              custom={{
                                format: 'HH:mm  DD/MM/YYYY',
                                minDate: moment(updateStartTime).toDate(),
                                maxDate: moment(updateStartTime).toDate(),
                              }}
                            />
                          </Box>
                          <Box flex="1 0 0" display="flex" justifyContent="center">
                            {
                              bookingTrackingList[0] && (
                                <a target="_blank" rel="noopener noreferrer" className={classes.linkMap}
                                  href={"https://maps.google.com/?q=" + bookingTrackingList[0].lat + "," + bookingTrackingList[0].lng}>
                                  <i className="fas fa-map-marked-alt" />
                                </a>
                              )
                            }
                          </Box>
                        </Box>
                        <Box display="flex" alignItems="center" padding="0.5rem 0">
                          <Box flex="3 0 0" display="flex" alignItems="center">
                            <Box className="mr-1" minWidth={90} fontWeight={700}>{t('label.endTime')}</Box>
                            {/* <Field
                              component={SelectTime}
                              name='endTime'
                              required
                              onSelected={(value) => {
                                setUpdateEndTime(value);
                              }}
                              minTime={shiftType === 'NIGHT'
                                ? moment().hours(0).minutes(0).format('HH:mm')
                                : moment().hours(6).minutes(0).format('HH:mm')
                              }
                              maxTime={shiftType === 'NIGHT'
                                ? moment().hours(6).minutes(moment(updateEndTime).hours() === 6 ? 0 : 59).format('HH:mm')
                                : moment().hours(23).minutes(59).format('HH:mm')
                              }
                              style={{
                                marginBottom: 0,
                                flex: '1 0 0px'
                              }}
                              isSleepover={shiftType === 'NIGHT'}
                            /> */}
                            <Field
                              component={CustomDateTimePicker}
                              name='endTime'
                              required
                              style={{ marginBottom: 0 }}
                              InputProps={{ fullWidth: true }}
                              hiddenIconClose={true}
                              notCheckTouched={true}
                              onChange={(value => {
                                setUpdateEndTime(moment(value).format('YYYY/MM/DD HH:mm'));
                              })}
                              custom={{
                                format: 'HH:mm  DD/MM/YYYY',
                                minDate: moment(updateStartTime).toDate(),
                              }}
                            />
                          </Box>
                          <Box flex="1 0 0" display="flex" justifyContent="center">
                            {
                              bookingTrackingList[1] && (
                                <a target="_blank" rel="noopener noreferrer" className={classes.linkMap}
                                  href={"https://maps.google.com/?q=" + bookingTrackingList[1].lat + "," + bookingTrackingList[1].lng}>
                                  <i className="fas fa-map-marked-alt" />
                                </a>
                              )
                            }
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        )
      }
      {
        bookingStatus && bookingStatus === BOOKING_STATUS.DONE && (
          <Box>
            <Box>{t('label.travel_history')}</Box>
            <Box display="flex" justifyContent="center">
              <TableContainer component={Paper} className={classes.trackingLog}>
                <Table className={classes.table} aria-label="spanning table">
                  <TableBody>
                    <TableRow>
                      <TableCell align="left" className={`${classes.bold} ${classes.travelHistoryLeft}`}>{t('label.distance')}</TableCell>
                      <TableCell align="left">{distance ? distance : '-'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" className={`${classes.bold} ${classes.travelHistoryLeft}`}>{t('label.origin_address')}</TableCell>
                      <TableCell align="left">
                        {
                          originLat && originLng && (
                            <a target="_blank" rel="noopener noreferrer"
                              href={"https://maps.google.com/?q=" + originLat + "," + originLng}>
                              {originAddress ? originAddress : <i className="fas fa-map-marked-alt" />}
                            </a>
                          )
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" className={`${classes.bold} ${classes.travelHistoryLeft}`}>{t('label.destination_address')}</TableCell>
                      <TableCell align="left">
                        {
                          destinationLat && destinationLng && (
                            <a target="_blank" rel="noopener noreferrer"
                              href={"https://maps.google.com/?q=" + destinationLat + "," + destinationLng}>
                              {destinationAddress ? destinationAddress : <i className="fas fa-map-marked-alt" />}
                            </a>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  </TableBody>
                  <TableFooter>
                    <TableCell align="right" colSpan={2} className={classes.travelHistoryFooter}>
                      <AppButton
                        label={t('button.update')}
                        onClick={() => {
                          setInitializeTravelHistory({
                            distance: distance || '',
                            originAddress: originAddress || '',
                            destinationAddress: destinationAddress || '',
                            latLngDestination: undefined,
                            latLngOrigin: undefined,
                          });
                          setShowUpdateTravelHistory(true);
                        }}
                      />
                    </TableCell>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        )
      }
      {/* {
        !isAdmin && estimate && (
          <Box>
            <Box>{t("label.estimatePrice")}</Box>
            <Box display="flex" justifyContent="center">
              <Box className={classes.wrapEstimate}>
                <Box display="flex" >
                  <Box flex="2 0 0px">
                    <Box>{t('label.time')}</Box>
                  </Box>
                  <Box flex="1 0 0px">
                    <Box>{t('label.total')}</Box>
                  </Box>
                </Box>
                {
                  estimate.dayTypes[0] && estimate.dayTypes[0].shifts && estimate.dayTypes[0].shifts.map((estimateShift, indexShift) => {
                    var totalPrice = 0;
                    var price = 0;
                    var estimatetotalHours = 0;
                    var shiftType = estimateShift.shiftType;
                    if (estimateShift.rate || estimateShift.rate === 0) {
                      totalPrice = estimateShift.rate * estimateShift.totalHours;
                      price = estimateShift.rate;
                      estimatetotalHours = estimateShift.totalHours;
                    } else {
                      totalPrice = estimateShift.segmentPrice ? estimateShift.segmentPrice : (estimateShift.remainingPrice ? estimateShift.remainingPrice : 0);
                      estimatetotalHours = estimateShift.segmentHours ? estimateShift.segmentHours : (estimateShift.remainingHours ? estimateShift.remainingHours : 0);
                      price = totalPrice / estimatetotalHours;
                    }
                    return (
                      <Box display="flex" key={`estimate-shift-details-${indexShift}`}>
                        <Box flex="2 0 0px">
                          <Box>
                            <span className={classes.bold}>{t('label.hoursValue', { value: estimatetotalHours })}</span>
                            <span>{` ${t(`shift.${shiftType}`)} at `}</span>
                            <span>{`$${price.toFixed(2)}/hour`}</span>
                          </Box>
                        </Box>
                        <Box flex="1 0 0px">
                          <Box className={classes.bold}>{`$${totalPrice}`}</Box>
                        </Box>
                      </Box>
                    );
                  })
                }
              </Box>
            </Box>
          </Box>
        )
      } */}
      {
        bookingStatus && bookingStatus !== BOOKING_STATUS.CANCEL && isAdmin && (
          <Box>
            {/* <Box>{t("label.selectedRate")}</Box>
            <Box display="flex" justifyContent="center">
              <Select
                name="select-specialty"
                className={classes.selectRate}
                styles={customStyles}
                value={selectedRate}
                options={listRate.map(item => {
                  return {
                    value: item.id,
                    label: item.name
                  }
                })}
                onChange={option => setSelectedRate(option)}
                isDisabled={bookingStatus === BOOKING_STATUS.DONE || bookingStatus === BOOKING_STATUS.CANCEL}
              />
            </Box> */}
            {
              (selectedRateMorning || selectedRateAfternoon || selectedRateEvening || selectedRateNight) && (
                <React.Fragment>
                  <Box>{t("label.estimatePriceWorker")}</Box>
                  <Box display="flex" justifyContent="center">
                    <Box className={classes.wrapEstimate}>
                      <Grid container spacing={1}>
                        <Grid item xs={5} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.rate')}</Box>
                        </Grid>
                        <Grid item xs={5} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.time')}</Box>
                        </Grid>
                        <Grid item xs={2} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.total')}</Box>
                        </Grid>
                      </Grid>
                      {
                        selectedRateMorning && selectedRateMorning.value &&
                        renderEstimatePrice(selectedRateMorning, true)
                      }
                      {
                        selectedRateAfternoon && selectedRateAfternoon.value &&
                        renderEstimatePrice(selectedRateAfternoon, true)
                      }
                      {
                        selectedRateEvening && selectedRateEvening.value &&
                        renderEstimatePrice(selectedRateEvening, true)
                      }
                      {
                        selectedRateNight && selectedRateNight.value &&
                        renderEstimatePrice(selectedRateNight, true)
                      }
                    </Box>
                  </Box>



                  <Box>{t("label.estimateParticipant")}</Box>
                  <Box display="flex" justifyContent="center">
                    <Box className={classes.wrapEstimate}>
                      <Grid container spacing={1}>
                        <Grid item xs={5} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.rate')}</Box>
                        </Grid>
                        <Grid item xs={5} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.time')}</Box>
                        </Grid>
                        <Grid item xs={2} className={isMobile ? classes.flexStart : classes.flexCenter}>
                          <Box>{t('label.total')}</Box>
                        </Grid>
                      </Grid>
                      {
                        selectedRateMorning && selectedRateMorning.value &&
                        renderEstimatePrice(selectedRateMorning, false)
                      }
                      {
                        selectedRateAfternoon && selectedRateAfternoon.value &&
                        renderEstimatePrice(selectedRateAfternoon, false)
                      }
                      {
                        selectedRateEvening && selectedRateEvening.value &&
                        renderEstimatePrice(selectedRateEvening, false)
                      }
                      {
                        selectedRateNight && selectedRateNight.value &&
                        renderEstimatePrice(selectedRateNight, false)
                      }
                    </Box>
                  </Box>
                </React.Fragment>
              )
            }
          </Box>
        )
      }
      {
        bookingStatus === BOOKING_STATUS.DONE && (
          <Box>
            <Box>{t("label.workerRating")}</Box>
            <Box display="flex" justifyContent="center" flexDirection='column' alignItems='center'>
              <Box className={classes.wrapRating}>
                <Box>{rating ? `${parseFloat(rating).toFixed(1)}/5` : '0/5'}</Box>
                <Box><Rating
                  name="read-only"
                  className={classes.rating}
                  value={rating ? parseFloat(rating.toFixed(1)) : 0}
                  readOnly
                  precision={0.1}
                /></Box>
              </Box>
              <Box className={classes.wrapVote}>
                <Box className={classes.wrapAvatar}>
                  <Avatar src={worker.avatarAws3Link ? worker.avatarAws3Link : AccountIcon} className={'avatar'} />
                </Box>
                <Box className='label-name'>{`${worker.firstName} ${worker.lastName}`}</Box>
                <Box style={{ color: AppColor.pink }}>{t('text.leaveRate', { value: `${worker.firstName} ${worker.lastName}` })}</Box>
                <Box>
                  <Rating
                    name="simple-controlled"
                    value={workerRating}
                    className={classes.rating}
                    onChange={(event, newValue) => {
                      setWorkerRating(newValue);
                    }}
                    readOnly={isAdmin || rating > 0}
                  />
                </Box>
                {
                  !isAdmin && !rating && (
                    <Box>
                      <AppButton
                        className='mr-1'
                        label={`${t("button.save")}`}
                        rounder
                        onClick={() => handleUpdateBooking()}
                        isLoading={isLoading}
                        disabled={isLoading || workerRating === 0}
                      />
                    </Box>
                  )
                }
              </Box>
            </Box>
          </Box>
        )
      }
      <Box className={classes.control}>
        <AppButton
          label={`${t("button.back")}`}
          mode="outlined"
          isLoading={isLoading}
          disabled={isLoading}
          className='mr-1'
          onClick={() => history.goBack()}
        />
        {
          isAdmin && (bookingStatus === BOOKING_STATUS.BOOKED || bookingStatus === BOOKING_STATUS.WAITING) && (
            <AppButton
              className='mr-1'
              label={`${t("button.cancelBooking")}`}
              buttonColor={AppColor.pink}
              onClick={() => setShowConfirmCancel(true)}
              isLoading={isLoading}
              disabled={isLoading}
            />
          )
        }
        {
          isAdmin && bookingStatus === BOOKING_STATUS.EXPRESS_INTEREST && (
            <>
              <AppButton
                className='mr-1'
                label={`${t("button.approve")}`}
                buttonColor={AppColor.mainColor}
                onClick={() => setShowConfirmApprove(true)}
                isLoading={isLoading}
                disabled={isLoading}
              />
              <AppButton
                className='mr-1'
                label={`${t("button.reject")}`}
                buttonColor={AppColor.red}
                onClick={() => setShowConfirmReject(true)}
                isLoading={isLoading}
                disabled={isLoading}
              />
            </>
          )
        }
        {
          bookingStatus && bookingStatus !== BOOKING_STATUS.CANCEL && bookingStatus !== BOOKING_STATUS.EXPRESS_INTEREST && isAdmin && (
            <AppButton
              label={`${t("button.save")}`}
              onClick={() => handleUpdateBooking()}
              isLoading={isLoading}
              disabled={isLoading || bookingStatus === BOOKING_STATUS.ON_GOING}
            />
          )
        }
        {
          bookingStatus && bookingStatus === BOOKING_STATUS.ON_GOING && isAdmin &&
          <AppButton
            label={t('button.endBooking')}
            className='ml-1'
            onClick={() => setShowEndBoking(true)}
            disabled={submitting}
            isLoading={submitting}
          />
        }
      </Box>
      <AppConfirmDialog
        open={showConfirmCancel}
        onConfirm={() => handleCancelBooking()}
        onClose={() => setShowConfirmCancel(false)}
        title={t('title.cancelBooking')}
        content={t('text.cancelBooking')}
      />
      <AppConfirmDialog
        open={showConfirmApprove}
        onConfirm={() => handleApprovalExpressInterest(true)}
        onClose={() => setShowConfirmApprove(false)}
        title={t('title.approveInterest')}
        content={t('text.approveInterest')}
      />
      <AppConfirmDialog
        open={showConfirmReject}
        onConfirm={() => handleApprovalExpressInterest(false)}
        onClose={() => setShowConfirmReject(false)}
        title={t('title.rejectInterest')}
        content={t('text.rejectInterest')}
      />

      <AppDialog
        open={showUpdateTravelHistory}
        onClose={() => setShowUpdateTravelHistory(false)}
        title={t('title.updateTravelHistory')}
      >
        <Formik
          initialValues={initializeTravelHistory}
          onSubmit={_submitUpdateTravelHistory}
          enableReinitialize
          validationSchema={Yup.object().shape({
            originAddress: Yup.string()
              .when('latLngOrigin', (latLngOrigin, schema) => {
                return schema.test('originAddress', 'validation.selectAddress', (originAddress) => {
                  if (originAddress && originAddress !== initializeTravelHistory.originAddress && (!latLngOrigin || !latLngOrigin.lat || !latLngOrigin.lng)) {
                    return false;
                  }
                  return true;
                })
              }),
            destinationAddress: Yup.string()
              .when('latLngDestination', (latLngDestination, schema) => {
                return schema.test('destinationAddress', 'validation.selectAddress', (destinationAddress) => {
                  if (destinationAddress && destinationAddress !== initializeTravelHistory.destinationAddress && (!latLngDestination || !latLngDestination.lat || !latLngDestination.lng)) {
                    return false;
                  }
                  return true;
                })
              }),
            distance: Yup.number()
              .min(1, { message: "validation.minValue", value: 1 }),
          })}
        >
          {({ handleSubmit, setFieldValue }) => (
            <>
              <Box>
                <Field
                  component={AppInput}
                  name="distance"
                  label={"label.distance"}
                  type="number"
                />
              </Box>

              <Box>
                <Field
                  component={InputAutocompleteAddress}
                  name="originAddress"
                  id="originAddress"
                  label={"label.origin_address"}
                  onChangeLatLng={latlng => {
                    setFieldValue("latLngOrigin", latlng);
                  }}
                  setLatLng={value => {
                    setFieldValue("latLngOrigin", value);
                  }}
                />
              </Box>
              <Box>
                <Field
                  component={InputAutocompleteAddress}
                  name="destinationAddress"
                  id="destinationAddress"
                  label={"label.destination_address"}
                  onChangeLatLng={latlng => {
                    setFieldValue("latLngDestination", latlng);
                  }}
                  setLatLng={value => {
                    setFieldValue("latLngDestination", value);
                  }}
                />
              </Box>

              <Box mt={2} style={{ marginTop: '3.5rem', display: "flex", justifyContent: "flex-end" }}>
                <AppButton
                  label={t('label.back')}
                  mode="outlined"
                  onClick={() => setShowUpdateTravelHistory(false)}
                  className="mr-2"
                />
                <AppButton
                  label={t('button.save')}
                  onClick={handleSubmit}
                  disabled={submitting}
                  isLoading={submitting}
                />
              </Box>
            </>
          )}
        </Formik>
      </AppDialog>
      <AppDialog
        open={showEndBoking}
        onClose={() => setShowEndBoking(false)}
        title={t('title.endBooking')}
      >
        <Formik
          initialValues={{ realEndTimeStr: moment() }}
          onSubmit={handleEndBooking}
          enableReinitialize
          validationSchema={Yup.object().shape({
            realEndTimeStr: Yup.string()
              .required(t('validation.required'))
              .test('realEndTimeStr', t('validation.minTime', { time: moment(realStartTime).format(FORMAT_DATE_TIME) }), (realEndTimeStr) => {
                if (!realEndTimeStr || realEndTimeStr === '') {
                  return true;
                }
                if (moment.range(moment(realStartTime), moment(realEndTimeStr)).diff("minutes") <= 0) {
                  return false;
                }
                return true;
              }),
          })}
        >
          {({ handleSubmit }) => (
            <>
              <Box>
                <Field
                  component={CustomDateTimePicker}
                  name="realEndTimeStr"
                  notUseTranslation={true}
                  required
                  InputProps={{ fullWidth: true }}
                  custom={{
                    format: FORMAT_DATE_TIME,
                    minDate: realStartTime ? moment(realStartTime).add(1, 'minutes').toDate() : moment().add(1, 'minutes').toDate()
                  }}
                />
              </Box>

              <Box mt={2} display="flex" justifyContent="flex-end" style={{ marginTop: '3.5rem' }}>
                <AppButton
                  label={t('label.back')}
                  mode="outlined"
                  onClick={() => setShowEndBoking(false)}
                  className="mr-2"
                />
                <AppButton
                  label={t('button.save')}
                  onClick={handleSubmit}
                  disabled={submitting}
                  isLoading={submitting}
                />
              </Box>
            </>
          )}
        </Formik>
      </AppDialog>
    </React.Fragment>
  )
}

export default ClientBookingForm;


// const data = [
//   {
//     id: 3533,
//     support_id: 29,
//     name: "AAA",
//     worker_type: "SUPPORT_WORKER",
//     rate_type: "STANDARD",
//     shift_type: "MORNING",
//     day_of_week: "WEEK_DAY",
//     pay_to_staff: 1,
//     bill_to_client: 1,
//     description: "",
//     ndis_code: "12",
//     status: "ACTIVE",
//     created_date: "2024-06-21 13:52:34",
//     worker_price: {
//       shift_type: "MORNING",
//       rate: 1,
//       hours: 19.58,
//       totalPrice: 19.58,
//     },
//     client_price: {
//       shift_type: "MORNING",
//       rate: 1,
//       hours: 19.58,
//       totalPrice: 19.58,
//     }
//   }
// ]